import { ModalContext } from "app/app";
import { Fragment, useContext } from "react";
import submitQuote from "views/website/images/popups/submitQuote.png";
import styles from "./styles.module.scss";

export function SubmitModal() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "submit_quote" && (
        <div className={styles.submitModal}>
          <div className={styles.modal}>
            <div className={styles.modalContent}>
              {/* <p>Reminder: the Cargo Categories listed in <span className='text-red-600'>RED</span> below are <span className='text-red-600'>ineligible</span> for Cover Whale. Have the insured <span className='text-blue-600'>update SAFER</span> if they are currently declaring any of these categories to avoid <span className='text-red-600'>CANCELLATION</span></p>
              <div className={styles.cargoTable}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th} colSpan="3">Cargo Carried</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={styles.td}>General Freight</td>
                  <td className={styles.td2}>Liquids/Gases</td>
                  <td className={styles.td2}>Chemicals</td>
                </tr>
                <tr>
                  <td className={styles.td}>Household Goods</td>
                  <td className={styles.td}>Intermodal Cont.</td>
                  <td className={styles.td}>Commodities Dry Bulk</td>
                </tr>
                <tr>
                  <td className={styles.td}>Metal: Sheets, Coils, Rolls</td>
                  <td className={styles.td2}>Passengers</td>
                  <td className={styles.td}>Refrigerated Food</td>
                </tr>
                <tr>
                  <td className={styles.td}>Motor Vehicles</td>
                  <td className={styles.td2}>Oilfield Equipment</td>
                  <td className={styles.td}>Beverages</td>
                </tr>
                <tr>
                  <td className={styles.td2}>Drive/Tow away</td>
                  <td className={styles.td2}>Livestock</td>
                  <td className={styles.td}>Paper Products</td>
                </tr>
                <tr>
                  <td className={styles.td}>Logs, Poles, Beams, Lumber</td>
                  <td className={styles.td}>Grain, Feed, Hay</td>
                  <td className={styles.td2}>Utilities</td>
                </tr>
                <tr>
                  <td className={styles.td}>Building Materials</td>
                  <td className={styles.td2}>Coal/Coke</td>
                  <td className={styles.td}>Agricultural/Farm Supplies</td>
                </tr>
                <tr>
                  <td className={styles.td2}>Mobile Homes</td>
                  <td className={styles.td}>Meat</td>
                  <td className={styles.td2}>Construction</td>
                </tr>
                <tr>
                  <td className={styles.td}>Machinery</td>
                  <td className={styles.td2}>Garbage/Refuse</td>
                  <td className={styles.td2}>Water Well</td>
                </tr>
                <tr>
                  <td className={styles.td}>Fresh Produce</td>
                  <td className={styles.td}>US Mail</td>
                </tr>
              </tbody>
            </table>
              </div> */}
              <img
                src={submitQuote}
                alt="Submit Quote"
                className={styles.submitQuoteImage}
              />
              <button className={styles.button} onClick={() => modal.action()}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
